import React, { Component } from "react";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import { HeaderLogo } from "../../store/types/appEssentials";
import Image from "../Image";
import VersionToggle from "./VersionToggle";

export default class Appbar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
    };
  }
  openModal = () => {
    this.setState({
      open: true,
    });
  };

  closeModal = () => {
    this.setState({
      open: false,
    });
  };

  render() {
    return (
      <div className="appbardiv">
        <AppBar
          position="static"
          color="inherit"
          className="appbar-div"
          style={{ boxShadow: "0px 0px 7px 0px lightgray" }}
        >
          <Toolbar
            style={{
              display: "flex",
              // borderBottom: "5px solid orange",
              justifyContent: this.props.center ? "center" : "space-between",
            }}
          >
            <a>
              <Image
                src={HeaderLogo}
                alt="logo_image"
                className="signIn-logo"
              />
            </a>
            <div className="toggle-wrapper">
              <VersionToggle />
            </div>

          </Toolbar>
        </AppBar>
      </div>
    );
  }
}

// <div className="home-bar">
// <a href="https://mfs.kfintech.com/mfs/" target="_blank">
//   Home
// </a>

// <a href="https://www.kfintech.com/about-us/" target="_blank">
//   About
// </a>

// <div className="client-services">
//   <a
//     style={{
//       textDecoration: "none",
//       fontSize: 14,
//       fontFamily: "Rubik",
//       padding: "0px 10px",
//       marginBottom: 3,
//       color: "#0076cb",
//     }}
//   >
//     Client Services
//   </a>
//   <div className="dropdown-client-services">
//     <div
//       style={{
//         display: "flex",
//         justifyContent: "flex-start",
//         marginRight: 25,
//       }}
//     >
//       <div
//         className="arrow-up"
//         style={{
//           borderLeft: "10px solid transparent",
//           borderRight: "10px solid transparent",
//           borderBottom: "10px solid #047cc7",
//           width: 0,
//           height: 0,
//         }}
//       />
//     </div>
//     <div className="client-services-a">
//       <a
//         href="https://mfs.kfintech.com/mfs/distributor/distributor_Login.aspx"
//         target="_blank"
//         style={{ padding: 10 }}
//       >
//         Distributor Services
//       </a>
//       <a
//         href="https://cpupload.kfintech.com/ChannelServices/CP_Login.aspx"
//         target="_blank"
//         style={{ padding: 10 }}
//       >
//         Channel Partner Services
//       </a>
//       <a
//         href="https://mfs.kfintech.com/investor/"
//         target="_blank"
//         style={{ padding: 10 }}
//       >
//         Mutual Fund Investor Services
//       </a>
//       <a
//         href="https://mfs.kfintech.com/econnect"
//         target="_blank"
//         style={{ padding: 10 }}
//       >
//         Korp Connect
//       </a>
//       <a
//         href="https://cpupload.kfintech.com/ChannelServices/RIA_Login.aspx"
//         target="_blank"
//         style={{ padding: 10 }}
//       >
//         RIA Services
//       </a>
//       <a
//         href="https://mfs.kfintech.com/karvyalternative/"
//         target="_blank"
//         style={{ padding: 10 }}
//       >
//         Alternative Investment Fund Investor
//       </a>
//       <a
//         href="https://fundswatch.kfintech.com/amcservices/"
//         target="_blank"
//         style={{ padding: 10 }}
//       >
//         AMC Services
//       </a>

//       <a
//         href="https://mfs.kfintech.com/FinancialServices"
//         target="_blank"
//         style={{ padding: 10 }}
//       >
//         Financial Services
//       </a>
//     </div>
//   </div>
// </div>

// <a href="https://www.kfintech.com/contact-us/" target="_blank">
//   Contact us
// </a>
// <button onClick={this.openModal}>Non Login Services</button>
// </div>

// <NonLoginServicesDialog
// open={this.state.open}
// closeModal={() => this.closeModal()}
// />
